const constants = {
  service_provider_profile: {
    music_page: 1,
    freelancer_page: 2,
    service_provider: 3,
    pearson_type: 1,
    legal_type: 2,
  },
  payment: {
    type_boleto_pix: 1,
    type_credit_card: 2,
  },
  payment_status: {
    free: 1,
    payment_ok: 2,
    payment_late: 3,
  },
  boost_plan: {
    free: 1,
    plus: 2,
    premium: 3,
  },
};

export default constants;
